'use strict';

module.exports = strong;

var all = require('../all');

/* Transform importance. */
function strong(h, node) {
  return h(node, 'strong', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/strong.js
// module id = 232
// module chunks = 96961042003272 139266963665775